import { Dialog, DialogBody, DialogFooter, DialogProps } from "@blueprintjs/core";
import classNames from "classnames";
import React from "react";

import styles from "./modal.module.css";

interface FDDialogProps extends DialogProps {
  actions?: React.ReactNode[];
}

export const Modal = ({ className, ...props }: FDDialogProps) => {
  return (
    <Dialog {...props} className={classNames(styles.modal, className)}>
      <DialogBody>{props.children}</DialogBody>
      <DialogFooter actions={props.actions} />
    </Dialog>
  );
};
